import React from 'react'
import style from './style.css'

/*https://icons8.com/cssload/en/horizontal-bars*/
export default class Spinner extends React.Component
{
    render()
    {
        return (
            <div id={style.fountainG}>
            	<div id={style.fountainG_1} className={style.fountainG}></div>
            	<div id={style.fountainG_2} className={style.fountainG}></div>
            	<div id={style.fountainG_3} className={style.fountainG}></div>
            	<div id={style.fountainG_4} className={style.fountainG}></div>
            	<div id={style.fountainG_5} className={style.fountainG}></div>
            </div>
     );
    }
}



// WEBPACK FOOTER //
// src/component/Spinner/FountainDrops/index.js